import styles from "./BulkActionsBarWrapper.module.css";

export function BulkActionsBarWrapper() {
  return (
    <div className={styles.root}>
      <div id="bulk-actions-bar" aria-live="polite" aria-atomic="false" />
    </div>
  );
}
